<template>
  <YoutubePlayer
    v-if="question.media?.type === 'video'"
    :video-id="youtubeId"
    @ended="$emit('ended')"
  />
  <MuxVideoPlayer
    v-else-if="question.media?.type === 'mux'"
    :media="question.media"
    @ended="$emit('ended')"
  />
</template>

<script lang="ts">
import { isNull, isUndefined } from 'ramda-adjunct'
import { computed, defineComponent, type PropType } from 'vue'

import { type Question } from '../../models/Question'
import MuxVideoPlayer from '../dumb/MuxVideoPlayer.vue'
import YoutubePlayer from '../dumb/YoutubePlayer.vue'

const shortsIdPrefix = '/shorts/'

const getYoutubeIdFromUrl = (link: string): string => {
  const url = new URL(link)
  if (!url.hostname.endsWith('youtube.com')) throw new Error('expected `link` to be a youtube link')

  const shortsId = url.pathname.startsWith(shortsIdPrefix)
    ? url.pathname.substring(shortsIdPrefix.length)
    : null

  const id = shortsId ?? new URLSearchParams(url.search).get('v')
  if (isNull(id)) throw new Error('expected `link` to have a `v` search param')

  return id
}

export default defineComponent({
  components: { YoutubePlayer, MuxVideoPlayer },
  props: {
    question: {
      required: true,
      type: Object as PropType<Pick<Question, 'media'>>,
    },
  },
  emits: {
    ended: () => true,
  },
  setup(props) {
    const youtubeId = computed(() => {
      if (isUndefined(props.question.media))
        throw new Error('expect currentQuestion.media to be defined')
      if (props.question.media.type === 'video') {
        return getYoutubeIdFromUrl(props.question.media.url)
      }

      if (props.question.media.type === 'mux') {
        return ''
      }

      throw new Error('expected media type to be video')
    })

    return { youtubeId }
  },
})
</script>
